import { html, render } from "lit";
import { IFinanzaCargoAplicado } from "../../../data/entidad/Finanza";
import { _SvFinanzasActualizarCargoAsignado } from "../../../data/modulo/FinanzaCargo";
import { _SvFinanzasObtenerCargoAplicadoPorID } from "../../../data/modulo/FinanzasAsignaciones";
import _L from "../../../util/Labels";
import { FormGenerator } from "../../controlD3/Formulario";
import { _ModalForm } from "../../controlD3/ModalThings/ModalForm";
import { IAsignacionCargoDesc } from "../../panelCard/Alumno/AlumnosCargosDescuentos";
import { UIUtilTime } from "../../util/Time";
import { _FinanzaCargoFormGetDatosFiscalesFields, EvalFormFacturationVisibility, TFinanzaCargoDataForm, TFinanzaCargoDatosFiscalesForm } from "../FinanzasIngresos/FinanzaCargoForm";

// const PERMISSION_MODULO = Entidad.CModulo.PanelFinanzasCargosDescuentos;
// const PERMISSION_ACTION = Entidad.CAccionPermiso.Editar;

enum CLoadStatus { Success, Error, Loading }

export class EditarCargoAsignadoConfigFiscalModal {
    /** Información completa de cargo asignado */
    private cargoInfo: IFinanzaCargoAplicado | null = null;
    private loadStatus: CLoadStatus = null;
    private cargoInfoWrapper: HTMLDivElement | null = null;

    private form: FormGenerator<TFinanzaCargoDatosFiscalesForm> | null = null;

    constructor(
        private idAlumno: number,
        private idEscuela: number,
        /** Cargo asignado */
        private asignacionCargo: IAsignacionCargoDesc,
        private onUpdateSuccess?: () => void
    ) {
        this.openModal();
    }

    private openModal() {
        _ModalForm({
            Title: _L("panelfinanzascargosdescuentos.tag_cfg_fiscal_edit"),
            Width: 550,
            GetForm: () => this.getForm(),
            DrawContent: (content, form) => {
                this.loadStatus = CLoadStatus.Loading;

                const cargoInfo = this.renderCargoInfo();
                cargoInfo.style.marginBottom = "var(--padding3)";

                content.node().appendChild(cargoInfo);

                content.node().appendChild(form._Form.node()); // el formulario al final

                _SvFinanzasObtenerCargoAplicadoPorID(this.asignacionCargo.ID).then((res) => {
                    this.cargoInfo = res.Datos;

                    const dataAsignar = { ...this.cargoInfo, IdEscuela: this.idEscuela } as unknown as TFinanzaCargoDatosFiscalesForm;
                    this.form._AsignaData(dataAsignar); // Asignar para poder evaluar Escuela y consultar listas desplegables relacionadas
                    EvalFormFacturationVisibility(this.form as unknown as FormGenerator<TFinanzaCargoDataForm>).then(() => { // Evaluar para mostrar/ocultar campos según la escuela seleccionada
                        this.form._AsignaData(dataAsignar); // Reasignar para mostrar los campos llenos
                        EvalFormFacturationVisibility(this.form as unknown as FormGenerator<TFinanzaCargoDataForm>); // Evaluar para aplicar los cambios según el agrupador seleccionado
                    });

                    this.loadStatus = res.Resultado > 0 && res.Datos ? CLoadStatus.Success : CLoadStatus.Error;
                    this.renderCargoInfo();
                });
            },
            OnAccept: (form) => {
                console.log(">>>", form._Data)
                const data = form._Data;
                return _SvFinanzasActualizarCargoAsignado({
                    IdCargo: this.asignacionCargo.ID,
                    IdAlumno: this.idAlumno,
                    IdEscuela: this.idEscuela,
                    IdAgrupador: data.IdAgrupador,
                    ClaveProdServSAT: data.ClaveProdServSAT,
                    NombreProdServSAT: data.NombreProdServSAT as string,
                    ClaveUnidadSAT: data.ClaveUnidadSAT,
                    NombreUnidadSAT: data.NombreUnidadSAT as string,
                    ComplementoRequerido: data.ComplementoRequerido,
                }).then(res => {
                    const resultadosRefrescar = [1 /* exitoso */, -1 /* No encontrado */, -2 /* No asignado */];
                    if (this.onUpdateSuccess && resultadosRefrescar.includes(res.Resultado)) {
                        this.onUpdateSuccess();
                    }
                    return res;
                })
            }
        })
    }

    private renderCargoInfo() {
        if (!this.cargoInfoWrapper) {
            const wrapper = document.createElement("div");
            wrapper.className = "body_informacion";
            this.cargoInfoWrapper = wrapper;
        }

        switch (this.loadStatus) {
            case CLoadStatus.Loading:
                render(html`
                    <label>${_L("general.loading")}</label>
                    <wc-spinner dim="10px" border-width="2px"></wc-spinner>
                `, this.cargoInfoWrapper);
                break;
            case CLoadStatus.Error:
                render(html`
                    <label style="color: var(--color_app_red1);">${_L("general.notif_fail_infosync")}</label>
                `, this.cargoInfoWrapper);
                break;
            case CLoadStatus.Success:
                const cargoAsignado = this.asignacionCargo;
                if (!this.cargoInfo) {
                    break;
                }

                const periodo = UIUtilTime._DateFormatStandar(cargoAsignado.FechaInicio) + (cargoAsignado.FechaFin ? " - " + UIUtilTime._DateFormatStandar(cargoAsignado.FechaFin) : "");
                render(html`
                    <p>
                        <b>${_L("panelfinanzascargosdescuentos.tag_cargo")}:</b>
                        ${this.cargoInfo.Nombre}
                    </p>
                    <p>
                        <b>${_L("panelfinanzascargosdescuentos.d_field_strperiodicidad")}:</b>
                        ${cargoAsignado.StrPeriodicidad}
                    </p>
                    <p>
                        <b>${_L("panelfinanzascargosdescuentos.d_field_norepeticiones")}:</b>
                        ${cargoAsignado.NoRepeticiones}
                    </p>
                    <p>
                        <b>${_L(!!cargoAsignado.FechaFin ? "panelfinanzascargosdescuentos.tag_periodo" : "panelfinanzascargosdescuentos.tag_aplicacion")}:</b>
                        ${periodo}
                    </p>
                `, this.cargoInfoWrapper);
                break;
        }
        return this.cargoInfoWrapper;
    }

    private getForm(): FormGenerator<TFinanzaCargoDatosFiscalesForm> {
        this.form = new FormGenerator<TFinanzaCargoDatosFiscalesForm>();
        this.form._Crear({
            LangModuleKeyInContext: "finanzascargo",
            schema: _FinanzaCargoFormGetDatosFiscalesFields(this.form as unknown as FormGenerator<TFinanzaCargoDataForm>, { IdEscuela: this.idEscuela } as TFinanzaCargoDataForm),
        })
        return this.form;
    }
}